<template>
    <section class="race-card container my-5">
        <div class="row align-items-center g-4 race-row">

            <!-- Imagen -->
            <div class="col-lg-2 col-md-3 text-center">
                <img src="@/assets/images/2026/banner2026.jpeg" alt="Carrera XHIDENXHI" class="race-image" />
            </div>

            <!-- Info principal -->
            <div class="col-lg-3 col-md-5 race-block with-divider">
                <h3 class="race-title">
                    XHIDENXHI Trail –<br />
                    Bioparque Estrella
                </h3>
                <p class="race-location">Estado de México</p>
            </div>

            <!-- Fecha / Hora -->
            <div class="col-lg-3 col-md-4 race-block with-divider" style="padding-left: 20px;">
                <p><strong>Fecha:</strong> Domingo 1 de marzo de 2026</p>
                <p><strong>Sede:</strong> Bioparque Estrella</p>
                <p><strong>Hora:</strong> 7:00 am</p>
                <p><strong>Distancia:</strong> 7 Km</p>
            </div>

            <!-- CTA -->
            <div class="col-lg-4 col-md-12 text-center" style="padding-left: 30px; padding-right: 30px;">
                <button class="btn-register w-100" @click="abrirWhats" disabled>
                    Registro finalizado
                </button>
            </div>

        </div>
    </section>
</template>

<script setup>
function abrirWhats () {
  window.open('https://api.whatsapp.com/send/?phone=525540861907&text&type=phone_number&app_absent=0')
}
</script>

<style scoped>
/* Estilos del card principal */
.race-card {
  background-color: #ffffff;
  border-radius: 20px;
  padding: 32px 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.race-image {
  width: 100%;
  max-width: 120px;
  border-radius: 14px;
}

.race-block {
  position: relative;
  padding-right: 24px;
}

.with-divider::after {
  content: '';
  position: absolute;
  top: 10%;
  right: 0;
  width: 4px;
  height: 80%;
  background-color: #e6e6e6;
  border-radius: 8px;
}

.race-title {
  font-family: 'GYMZain', sans-serif;
  font-size: 1.6rem;
  color: #1B1E20;
  margin-bottom: 8px;
}

.race-location {
  color: #DD611F;
  font-weight: 600;
}

.btn-register {
  background-color: #DD611F;
  color: #ffffff;
  padding: 16px 20px;
  border-radius: 14px;
  font-weight: 600;
  border: 0px solid transparent;
  font-size: 1.1rem;
}

@media (max-width: 991px) {
  .with-divider::after {
    display: none;
  }

  .race-card {
    text-align: center;
  }
}
</style>
